class Countdown extends HTMLElement {
  constructor() {
    super();

    this.countdown = this.querySelector(".js-countdown");
    this.date = this.getAttribute("js-countdown-date");
    this.countDownDate = Date.parse(this.date);
    
    this.initialiseCountdown();
  }
  
  getTimeRemaining() {
    const now = new Date().getTime();
    const total = this.countDownDate - now;
    const days = Math.floor(total / (1000 * 60 * 60 * 24));
    const hours = Math.floor((total % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((total % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((total % (1000 * 60)) / 1000);
    
    return {
      total,
      days,
      hours,
      minutes,
      seconds
    };
  }
  
  initialiseCountdown() {
    this.updateCountdown();
    this.interval = setInterval(this.updateCountdown.bind(this), 1000);

    if (this.getTimeRemaining().total < 0) {
      clearInterval(this.interval);

      this.countdown.classList.add("hidden");
    }
  }
  
  updateCountdown() {
    const time = this.getTimeRemaining();
    const daysSpan = this.countdown.querySelector(".countdown__days");
    const hoursSpan = this.countdown.querySelector(".countdown__hours");
    const minutesSpan = this.countdown.querySelector(".countdown__minutes");
    const secondsSpan = this.countdown.querySelector(".countdown__seconds");
    
    daysSpan.innerHTML = time.days > 0 ? time.days + "d" : "";
    hoursSpan.innerHTML = time.hours > 0 ? time.hours + "h" : "";
    minutesSpan.innerHTML = time.minutes > 0 ? this.formatTime(time.minutes) + "m" : "";
    secondsSpan.innerHTML = time.seconds > 0 ? this.formatTime(time.seconds) + "s" : "";
  }
  
  formatTime(time) {
    return ('0' + time).slice(-2);
  }
}

customElements.define("countdown-timer", Countdown);